import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import useFetch from "../../../../../hooks/useFetch";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { NumericFormat } from "react-number-format";
import useFormattedLocalDate from "../../../../../hooks/useFormattedLocalDate";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "signed-check-form";

const SigendCheck = forwardRef(({ close, get, edit, Id }, ref) => {
  const formatDate = useFormattedLocalDate();

  const [call, setCall] = useState({
    amout: "",
    check_date: undefined,
    check_number: "",
    bank: "",
    student: Id,
    description: "",
  });

  const newGroup = useFetch({
    method: "POST",
    url: `management/signedcheck/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });

  const editMoney = useFetch({
    method: "PATCH",
    url: `management/signedcheck/${edit}/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });

  const getMoney = useFetch({
    method: "GET",
    url: `management/signedcheck/${edit}/`,
    noHeader: false,
    trigger: edit ? true : false,
    setter: setCall,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: call,
  });

  const onSubmit = (e) => {
    if (edit) {
      editMoney.reFetch();
    } else {
      newGroup.reFetch();
    }
  };

  useEffect(() => {
    newGroup.status === 201 && close();
    editMoney.status === 200 && close();
    setCall({
      amout: "",
      check_date: undefined,
      check_number: "",
      bank: "",
      student: Id,
      description: "",
    });
  }, [newGroup.status, editMoney.status]);

  const submitting = newGroup.loading || editMoney.loading;

  return (
    <ModalShell
      ref={ref}
      close={close}
      title={edit ? "ویرایش چک" : "چک جدید"}
      subtitle="مبلغ، تاریخ و شماره چک"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={submitting}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {submitting ? "در حال ثبت…" : "ثبت چک"}
          </button>
        </div>
      }
    >
      <form
        id={FORM_ID}
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-lg text-sm"
      >
        <div>
          <NumericFormat
            customInput={TextField}
            thousandSeparator
            name="amout"
            label="مبلغ"
            value={call.amout}
            onValueChange={(e) => {
              setCall({ ...call, amout: e.value });
            }}
            error={!!errors?.amout}
            helperText={errors?.amout?.message || ""}
            fullWidth
            valueIsNumericString
          />
        </div>
        <div>
          <MobileDatePicker
            label="تاریخ"
            onChange={(e) => {
              const date = formatDate(e);
              setCall((prev) => ({
                ...prev,
                check_date: date,
              }));
            }}
            value={call.check_date ? new Date(call.check_date) : null}
            views={["year", "month", "day"]}
            className="!text-6xl w-full"
            slotProps={{
              field: { shouldRespectLeadingZeros: true },
              toolbar: { hidden: true },
              tabs: { hidden: true },
            }}
          />
        </div>
        <div>
          <TextField
            name="check_number"
            value={call.check_number}
            label="شماره چک"
            {...register("check_number", {
              required: "شماره چک را وارد کنید",
            })}
            error={!!errors.check_number}
            helperText={errors.check_number ? errors.check_number.message : ""}
            onChange={(e) => {
              setCall({ ...call, check_number: e.target.value });
            }}
            fullWidth
          />
        </div>
        <div>
          <TextField
            name="description"
            value={call.description}
            label="توضیحات"
            {...register("description", {})}
            error={!!errors.description}
            helperText={errors.description ? errors.description.message : ""}
            onChange={(e) => {
              setCall({ ...call, description: e.target.value });
            }}
            fullWidth
          />
        </div>

        <div>
          <TextField
            name="bank"
            value={call.bank}
            label="بانک"
            {...register("bank", {
              required: "بانک را وارد کنید",
            })}
            error={!!errors.bank}
            helperText={errors.bank ? errors.bank.message : ""}
            onChange={(e) => {
              setCall({ ...call, bank: e.target.value });
            }}
            fullWidth
          />
        </div>
      </form>
    </ModalShell>
  );
});

export default SigendCheck;
